export default __webpack_public_path__ + "static/media/eqe.0e1a6588.svg";